var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-block" }, [
    _c("ul", [
      _c("li", { staticClass: "account-block" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/img/icon/member_icon.png"), alt: "" },
        }),
        _c("span", [_vm._v(_vm._s(_vm.account))]),
      ]),
      _c("li", { staticClass: "balance-block" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: _vm.getImgUrl(), alt: "" },
        }),
        _c("span", [
          _vm._v(_vm._s(_vm._f("moneyHandler")(_vm._f("amount")(_vm.balance)))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }